import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtLoginPopupCtrl($scope) {
  this.showLoginPopup = $scope.showLoginPopup;

  this.close = function () {
    $scope.showLoginPopup = false;
  };
}

App.controller('LtLoginPopupCtrl', ['$scope', LtLoginPopupCtrl]);
